
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { CheckCircle2, AlertCircle } from 'lucide-react';
import { CertificateNumberInventory } from '@/utils/certificateInventoryTypes';

interface CertificateStatusBadgeProps {
  type: 'reporting' | 'verification';
  item: CertificateNumberInventory;
}

export function CertificateStatusBadge({ type, item }: CertificateStatusBadgeProps) {
  if (type === 'reporting') {
    if (item.reporting_status === 'reported') {
      return (
        <Badge variant="success" className="flex gap-1 items-center">
          <CheckCircle2 className="h-3 w-3" /> Reported
        </Badge>
      );
    } else if (item.is_used && !item.reported) {
      return (
        <Badge variant="destructive" className="flex gap-1 items-center">
          <AlertCircle className="h-3 w-3" /> Used but not reported
        </Badge>
      );
    } else {
      return <Badge variant="outline">Not reported</Badge>;
    }
  } else if (type === 'verification') {
    if (item.verification_status === 'verified') {
      return (
        <Badge variant="success" className="flex gap-1 items-center">
          <CheckCircle2 className="h-3 w-3" /> Verified
        </Badge>
      );
    } else {
      return <Badge variant="outline">Not verified</Badge>;
    }
  }
  
  return null;
}
